import { LeagueMode } from "./leaderboard/types";
import ModeIcon from "../ModeIcon";

/** Small mode glyph used next to the mode label in a league page's header
 * metadata row (LeaguePage and every per-mode page — TeamPage, GwChallengePage,
 * PredictionPage, SyndicatePage — share this exact treatment). Thin wrapper around
 * the shared ModeIcon geometry at this badge's fixed size/stroke/no-fill-inherit shape. */
export default function ModeIconSmall({ mode, color }: { mode: LeagueMode; color: string }) {
  return (
    <span style={{ flexShrink: 0, display: "inline-flex" }}>
      <ModeIcon mode={mode} size={13} strokeWidth={2} color={color} />
    </span>
  );
}
